import { menu, menuProducts, body } from "../services/variables.js";

function showProducts(
	menuFullWhite,
	menuForBigProduct,
	menuShow,
	overflowHidden
) {
	menu.classList.toggle(menuFullWhite);
	menu.classList.toggle(menuForBigProduct);
	menuProducts.classList.toggle(menuShow);
	body.classList.toggle(overflowHidden);
}

export default showProducts;
